import React, { useState, useEffect } from 'react';
import {
    Box, Button, Card, CardContent, CardMedia, Typography,IconButton, Badge
} from '@mui/material';
import {ShoppingCart, Close as CloseIcon } from '@mui/icons-material';
import img1 from '../assests/foods/BBQ.png';
import img2 from '../assests/foods/dumstic.png';
import img3 from '../assests/foods/leg.png';
import img4 from '../assests/foods/rice.png';
import img5 from '../assests/foods/submarine.png';
import img6 from '../assests/foods/thig.png';
import img7 from '../assests/foods/wings.png';
import img8 from '../assests/foods/soft 500ml.png';
import img9 from '../assests/foods/soft 1L.png';
import img10 from '../assests/foods/soda 500ml.png';
import img11 from '../assests/foods/soda 1L.png';
import Cart from "../component/Cart";
import { Fullscreen, FullscreenExit } from '@mui/icons-material';


export const Dashboard = () => {
    const [filter, setFilter] = useState('All');
    const [searchQuery] = useState('');
    const [cartItems, setCartItems] = useState(() => {
        const saved = localStorage.getItem('cartItems');
        return saved ? JSON.parse(saved) : [];
    });
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [showQuantityPad, setShowQuantityPad] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null);

    useEffect(() => {
        localStorage.setItem('cartItems', JSON.stringify(cartItems));
    }, [cartItems]);

    useEffect(() => {
        document.body.style.overflow = (showQuantityPad || isCartOpen) ? 'hidden' : '';
    }, [showQuantityPad, isCartOpen]);

    const dishes = [
        { name: 'Fried Wings', description: 'Juicy grilled chicken...', price: 180, category: 'Snack', image: img7 },
        { name: 'Fried Drumstick', description: 'Classic Italian pasta...', price: 320, category: 'Snack', image: img2 },
        { name: 'Fried Legs', description: 'Crisp romaine lettuce...', price: 650, category: 'Snack', image: img3 },
        { name: 'Fried Thigh', description: 'Traditional pizza...', price: 500, category: 'Snack', image: img6 },
        { name: 'Fried Rice', description: 'Classic beef burger...', price: 800, category: 'Rice', image: img4 },
        { name: 'Fried Submarine', description: 'Classic beef burger...', price: 350, category: 'Burger', image: img5 },
        { name: 'BBQ', description: 'Classic beef burger...', price: 750, category: 'Snack', image: img1 },
        { name: 'Soft Drink-500ML', description: 'Classic beef burger...', price: 180, category: 'Beverage', image: img8 },
        { name: 'Soft Drink-1L', description: 'Classic beef burger...', price: 300, category: 'Beverage', image: img9 },
        { name: 'Soda-500ML', description: 'Classic beef burger...', price: 120, category: 'Beverage', image: img10 },
        { name: 'Soda-1L', description: 'Classic beef burger...', price: 180, category: 'Beverage', image: img11 },
    ];

    const QuantityPad = ({ onConfirm, onCancel }) => {
        const [quantityStr, setQuantityStr] = useState('');

        const handleNumberClick = (num) => {
            setQuantityStr((prev) => (prev === '0' ? String(num) : prev + num));
        };

        const handleClear = () => setQuantityStr('');

        const handleEnter = () => {
            const qty = parseInt(quantityStr, 10);
            if (!qty || qty <= 0) {
                alert('Please enter a quantity greater than zero');
                return;
            }
            onConfirm(qty);
            setQuantityStr('');
        };

        return (
            <Box
                sx={{
                    maxWidth: 300,
                    margin: 'auto',
                    p: 2,
                    border: '1px solid #ccc',
                    borderRadius: 2,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1300,
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h6" textAlign="center">
                        {selectedDish?.name || 'Enter Quantity'}
                    </Typography>
                    <IconButton onClick={() => { setQuantityStr(''); onCancel(); }}>
                        <CloseIcon />
                    </IconButton>
                </Box>



                <Typography
                    variant="h4"
                    textAlign="center"
                    mb={2}
                    sx={{
                        border: '1px solid #888',
                        borderRadius: 1,
                        p: 1,
                        minHeight: 56,
                        fontWeight: 'bold',
                        letterSpacing: 4,
                        backgroundColor: '#f0f0f0',
                    }}
                >
                    {quantityStr || '0'}
                </Typography>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: 1,
                        mb: 2,
                        justifyItems: 'center',
                    }}
                >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                        <Button
                            key={num}
                            variant="outlined"
                            size="large"
                            onClick={() => handleNumberClick(num)}
                            sx={{ fontSize: '1.5rem', fontWeight: '600' }}
                        >
                            {num}
                        </Button>
                    ))}
                    <Box />
                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => handleNumberClick(0)}
                        sx={{ fontSize: '1.5rem', fontWeight: '600' }}
                    >
                        0
                    </Button>
                    <Box />
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={handleClear}
                        sx={{ minWidth: 100, fontSize: '1rem' }}
                    >
                        Clear
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleEnter}
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1.25rem',
                            backgroundColor: 'orange',
                            minWidth: 140,
                            px: 3,
                            '&:hover': { backgroundColor: '#ff9800' },
                            borderRadius: 2,
                            alignSelf: 'center'
                        }}
                    >
                        Add
                    </Button>
                </Box>

            </Box>
        );
    };

    const handleDishClick = (dish) => {
        setSelectedDish(dish);
        setShowQuantityPad(true);
    };

    const handleAddToCartWithQuantity = (quantity) => {
        if (!selectedDish) return;
        const existingItem = cartItems.find(item => item.name === selectedDish.name);
        const updatedCart = existingItem
            ? cartItems.map(item =>
                item.name === selectedDish.name ? { ...item, quantity: item.quantity + quantity } : item
            )
            : [...cartItems, { ...selectedDish, quantity }];
        setCartItems(updatedCart);
        setShowQuantityPad(false);
        setSelectedDish(null);
    };

    const handleCancelQuantityPad = () => {
        setShowQuantityPad(false);
        setSelectedDish(null);
    };

    const handleRemoveItem = (index) => setCartItems(cartItems.filter((_, i) => i !== index));
    const handleIncreaseQuantity = (index) => setCartItems(cartItems.map((item, i) =>
        i === index ? { ...item, quantity: item.quantity + 1 } : item));
    const handleDecreaseQuantity = (index) => setCartItems(cartItems.map((item, i) =>
        i === index && item.quantity > 1 ? { ...item, quantity: item.quantity - 1 } : item));
    const handleCloseCart = () => setIsCartOpen(false);
    const clearCart = () => setCartItems([]);

    const filteredDishes = dishes
        .filter(dish => filter === 'All' || dish.category === filter)
        .filter(dish =>
            dish.name.toLowerCase().includes(searchQuery) ||
            dish.description.toLowerCase().includes(searchQuery)
        );

    const [isFullscreen, setIsFullscreen] = useState(false);

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().then(() => setIsFullscreen(true));
        } else {
            document.exitFullscreen().then(() => setIsFullscreen(false));
        }
    };


    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    zIndex: 1100,
                    display: 'flex',
                    gap: 1,
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    padding: '16px'
                }}
            >
                <IconButton onClick={toggleFullscreen} sx={{   mr: { sm:'200px', md: '200px', xl:'350px'},}}> <small>Full Screen</small>
                    {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
                </IconButton>

                <IconButton sx={{ background: 'white', width: '110px' }} onClick={() => setIsCartOpen(true)}>
                    <Badge badgeContent={cartItems.reduce((total, item) => total + item.quantity, 0)} color="error">
                        <ShoppingCart />
                    </Badge>
                </IconButton>
            </Box>


            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 4 }}>
                {['All', 'Snack', 'Beverage', 'Rice', 'Burger'].map((cat) => (
                    <Button
                        key={cat}
                        variant={filter === cat ? 'contained' : 'outlined'}
                        sx={{ backgroundColor: filter === cat ? 'orange' : 'default' }}
                        onClick={() => setFilter(cat)}
                    >
                        {cat}
                    </Button>
                ))}
            </Box>

            {/*search bar*/}
            {/*<Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
                <TextField
                    variant="outlined"
                    placeholder="Search..."
                    size="small"
                    value={searchQuery}
                    sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, border: '2px solid orange', width: '300px' }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search color="action" />
                            </InputAdornment>
                        ),
                        endAdornment: searchQuery && (
                            <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                <Clear color="action" onClick={() => setSearchQuery('')} />
                            </InputAdornment>
                        )
                    }}
                    onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                />
            </Box>*/}

            <Box
                sx={{
                    display: 'grid',
                    gap: 3,
                    gridTemplateColumns: {
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(3, 1fr)',
                        md: 'repeat(4, 1fr)'
                    },
                    p: 4,
                    mt: 0,
                    backgroundColor: '#f9f9f9',
                    borderRadius: 2,
                    minHeight: 300,
                    justifyContent: filteredDishes.length === 0 ? 'center' : 'initial'
                }}
            >
                {filteredDishes.length === 0 ? (
                    <Typography variant="h6" color="text.secondary" sx={{ gridColumn: '1 / -1', textAlign: 'center' }}>
                        No dishes found.
                    </Typography>
                ) : (
                    filteredDishes.map((dish, index) => (
                        <Card
                            key={index}
                            onClick={() => handleDishClick(dish)}
                            sx={{
                                borderRadius: 4,
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                border: '2px solid orange',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.03)',
                                    boxShadow: '0 6px 25px rgba(0,0,0,0.15)',
                                    cursor: 'pointer',
                                },
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundColor: 'white',
                            }}
                        >
                            <CardMedia
                                component="img"
                                image={dish.image}
                                alt={dish.name}
                                sx={{
                                    width: '100%',
                                    aspectRatio: '16 / 9',
                                    objectFit: 'cover',
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                }}
                            />
                            <CardContent sx={{ p: 2, textAlign: 'center' }}>
                                <Typography gutterBottom variant="h6" sx={{ fontWeight: 600 }}>
                                    {dish.name}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ mt: 1, color: 'white', fontWeight: 700, backgroundColor: 'orange', borderRadius: 10 }}>
                                    Rs. {dish.price}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))
                )}
            </Box>

            {showQuantityPad && (
                <QuantityPad
                    onConfirm={handleAddToCartWithQuantity}
                    onCancel={handleCancelQuantityPad}
                />
            )}

            {isCartOpen && (
                <Cart
                    cartItems={cartItems}
                    onRemoveItem={handleRemoveItem}
                    onIncreaseQuantity={handleIncreaseQuantity}
                    onDecreaseQuantity={handleDecreaseQuantity}
                    onClose={handleCloseCart}
                    onClearCart={clearCart}
                />
            )}
        </>
    );
};
